import { render, staticRenderFns } from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=template&id=68a45099&scoped=true"
import script from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=script&lang=js"
export * from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=script&lang=js"
import style0 from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=style&index=0&id=68a45099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a45099",
  null
  
)

export default component.exports